export var TosName;
(function (TosName) {
    TosName["CLIENT"] = "Client Terms of Service";
    TosName["PARTNER"] = "Partner Terms of Service";
    TosName["DIRECT_CLIENT_MARKETPLACE"] = "Direct Client Marketplace Terms Of Service";
})(TosName || (TosName = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidG9zLnR5cGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsidG9zLnR5cGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQTBCQSxNQUFNLENBQU4sSUFBWSxPQUlYO0FBSkQsV0FBWSxPQUFPO0lBQ2pCLDZDQUFrQyxDQUFBO0lBQ2xDLCtDQUFvQyxDQUFBO0lBQ3BDLG1GQUF3RSxDQUFBO0FBQzFFLENBQUMsRUFKVyxPQUFPLEtBQVAsT0FBTyxRQUlsQiJ9